import { useEffect, useState } from "react";
import { database } from "firebase/app";

/**
 * Connect to database by ref and update number of children
 * @param {string} path - database reference
 * @param {object} [initObject] - initial value object
 * @return {number}
 * */
export const useSubscribeInstanceLength = (path: string, initObject: Record<string, string> | undefined) => {
  const [length, setLength] = useState<number>(initObject ?  Object.keys(initObject).length : 0);
  /*
  * add listener to database by path.
  * update length if any children was changed
  * remove listener if unmount.
  * */
  useEffect(() => {
    /* order: https://firebase.google.com/docs/database/admin/retrieve-data#orderbychild */
    const instanceRef = database().ref(path).orderByChild("isArchived").startAt(null).endAt(false);

    const callback = (snapshot: database.DataSnapshot) => {
      setLength(snapshot.numChildren());
    };

    instanceRef.on("value", callback);

    return () => {
      instanceRef.off("value", callback);
    };
  }, [path]);

  return length;
};
